import AdPlacementsModal from "./ad_placements_modal";
import { hideModal } from "../../actions/modal";
import {
  adPlacementsModalClear,
  adPlacementsModalDeletePlacement,
  adPlacementsModalSetPlacement,
  adPlacementsModalSetCursor,
} from "../../actions/ad_placements_modal";
import { MediaFileActionManager } from "../../action_managers/shows";
import AdPlacementActionManager from "../../action_managers/ad_placement";
import { connect } from "react-redux";
import { withRouter } from "react-router";

function mapStateToProps(state) {
  return {
    user: state.user.user,
    mediaFiles: state.mediaFiles,
    placements: state.adPlacementsModal.placements,
    isLoading: state.adPlacementsModal.isLoading,
    isSuccess: state.adPlacementsModal.isSuccess,
    cursor: state.adPlacementsModal.cursor,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    closeModal: () => {
      dispatch(hideModal());
    },
    fetchMediaFile: (mediaFileUUID, authToken) => {
      dispatch(new MediaFileActionManager({ mediaFileUUID, authToken }).run());
    },
    savePlacements: (episodeUUID, placements, user) => {
      var manager = new AdPlacementActionManager({
        episode: {
          adPlacements: placements,
          uuid: episodeUUID,
        },
        authToken: user.authToken,
      });
      dispatch(manager.run());
    },
    deletePlacement: index => {
      dispatch(adPlacementsModalDeletePlacement(index));
    },
    setPlacement: placement => {
      dispatch(adPlacementsModalSetPlacement(placement));
    },
    clearForm: episode => {
      dispatch(adPlacementsModalClear(episode));
    },
    setCursor: cursor => {
      dispatch(adPlacementsModalSetCursor(Math.round(cursor * 1000)));
    },
  };
}

const AdPlacementsModalWrapper = withRouter(
  connect(mapStateToProps, mapDispatchToProps)(AdPlacementsModal)
);

export default AdPlacementsModalWrapper;
